// extracted by mini-css-extract-plugin
export default {"root":"MDTBalancePage_root__EgAsq","nav":"MDTBalancePage_nav__TGmSW","wrapper":"MDTBalancePage_wrapper__2xXj+"};